import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import SlotCalendar from 'src/components/appointments/SlotCalendar';
import { MCButton } from 'src/components/basic';
import { DoctorProfileCard, PatientProfileCard } from 'src/components/complex';
import AlertManager from 'src/components/alert';
import { lang, remCss } from 'src/helpers';

import { BOOK_TYPE, STEPS } from './constants';
import AppointmentStatus from 'src/components/appointments/AppointmentStatus';
import LANG_CONST from 'src/helpers/lang/const';

export class BookSlots extends BaseComponent {
  get model() {
    return this.props.model;
  }

  get config() {
    return this.props.config;
  }

  componentDidMount() {
    this.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.model.unsubscribe(this.subscription);
  }
  next = async (e) => {
    e.preventDefault();
    const error = this.model.checkValidSlot();
    if (error) {
      AlertManager.popup(AlertManager.TYPES.WARN, {
        title: error,
        close: false,
        actionButton: {
          label: LANG_CONST.buttons.ok,
          action: (actions) => actions.hide()
        }
      });
    } else {
      if (this.model.state.selectedType === 'in_office') {
        this.model.loadHospital(this.model.state.selectedSlot.hospitalId);
      }
      this.model.nextStep(
        this.model.state.selectedType === 'in_office' ? STEPS.OFFICE : STEPS.INFO
      );
    }
  };
  onRescheduled = (res) => {
    const invoiceId = res?.invoice?.id;
    if (this.config.payNowEnabled && this.model.state.payNow && invoiceId) {
      setTimeout(() => this.navigate('/invoices/payment/' + invoiceId), 0);
    } else if (this.props.onDone) this.props.onDone();
    else this.navigate('/appointments');
  };

  save = (event) => {
    event.preventDefault();
    const error = this.model.checkValidSlot();
    if (error) {
      AlertManager.popup(AlertManager.TYPES.WARN, {
        title: error,
        close: false,
        actionButton: {
          label: LANG_CONST.buttons.ok,
          action: (actions) => actions.hide()
        }
      });
    } else {
      if (!this.model.isSamePrice()) {
        AlertManager.popup(AlertManager.TYPES.INFO, {
          title: LANG_CONST.notice.reschedule_diff,
          maxWidth: remCss(550),
          close: false,
          cancelButton: {
            label: LANG_CONST.buttons.no,
            action: (actions) => actions.hide()
          },
          actionButton: {
            label: LANG_CONST.buttons.yes,
            action: (actions) => {
              actions.hide();
              this.model.rescheduleAppointment((res, success) => {
                if (success) {
                  this.onRescheduled(res);
                }
              });
            }
          }
        });
      } else
        this.model.rescheduleAppointment((res, success) => {
          if (success) {
            this.onRescheduled(res);
          }
        });
    }
  };

  render = () => {
    const { loading } = this.model.getApiState(this.model.state.saveApi);

    const slotCalendar = (
      <div className={'mc-grow mc-flex-20-col'}>
        <SlotCalendar
          ref={(r) => {
            this.ref = r;
            this.props.onCalendarRef && this.props.onCalendarRef(r);
          }}
          fees={this.model.getFees()}
          currency={this.model.getCurrency()}
          loading={this.model.getApiState('getSlots').loading}
          slots={this.model.state.slots}
          selectedDay={this.model.state.selectedDay}
          selectedSlot={this.model.state.selectedSlot}
          selectedType={this.model.state.selectedType}
          payNow={this.model.input('payNow')}
          payLifeapp={this.model.input('payLifeapp')}
          handleChangeSelectedMonth={(v) => {
            this.model.handleChangeSelectedMonth(v, () =>
              setTimeout(() => this.ref?.scrollToDate(), 500)
            );
          }}
          isPatient={this.model.state.user?.isPatient}
          handleChangeSelectedDay={this.model.handleChangeSelectedDay}
          handleChangeSelectedSlot={this.model.handleChangeSelectedSlot}
          handleChangeSelectedType={(value) => this.model.handleChange('selectedType', value)}
          handleChangePayNow={
            !this.config.payNowEnabled || this.model.isSamePrice()
              ? null
              : (v) => this.model.handleChange('payNow', v)
          }
          handleChangePayLifeapp={
            this.model.isSamePrice() ? null : (v) => this.model.handleChange('payLifeapp', v)
          }
        />
      </div>
    );

    if (this.model.state.type === BOOK_TYPE.RESCHEDULE) {
      const { doctor, user, appointment } = this.model.state;
      return (
        <div className={'mc-tab-content'}>
          <div className={'mc-flex mc-grow'} style={{ overflow: 'auto' }}>
            <div className={'mc-container-content__body-left mc-flex-20-col'}>
              {appointment?.patient?.id !== user?.id ? (
                <>
                  <PatientProfileCard patient={appointment.patient} />
                  <div className={'mc-flex-col mc-grow mc-bt mc-pt20'}>
                    <div className={'mc-label-416'}>{lang.t('Appointment Status')}</div>
                    <div style={{ width: remCss(120) }}>
                      <AppointmentStatus appointment={appointment} />
                    </div>
                  </div>
                </>
              ) : (
                <DoctorProfileCard doctor={doctor} />
              )}
            </div>
            <div className={'mc-container-content__body-center'} style={{ paddingRight: 0 }}>
              {slotCalendar}
            </div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-grow'} />
            <MCButton
              primary
              medium
              radius
              dark
              label={'Reschedule appointment'}
              disabled={loading}
              loading={loading}
              onClick={this.save}
            />
          </div>
        </div>
      );
    }

    return (
      <div
        className={'mc-tab-content ' + (this.model.state.step === STEPS.SLOTS ? '' : 'mc-inactive')}
      >
        {slotCalendar}
        <div className={'mc-flex-20'}>
          {this.model.state.historySteps.length > 0 && (
            <MCButton
              light
              primary
              radius
              medium
              disabled={loading}
              onClick={(e) => {
                e.preventDefault();
                this.model.previousStep();
              }}
              style={{ width: remCss(100) }}
              label={LANG_CONST.buttons.back}
            />
          )}
          <div className={'mc-grow'} />
          <MCButton
            primary
            medium
            radius
            light
            style={{ width: remCss(100) }}
            label={LANG_CONST.buttons.cancel}
            disabled={loading}
            onClick={this.props.onBack}
          />
          <MCButton
            primary
            medium
            radius
            dark
            label={LANG_CONST.buttons.next}
            style={{ width: remCss(100) }}
            disabled={loading}
            loading={loading}
            onClick={this.next}
          />
        </div>
      </div>
    );
  };
}
